var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SkeletonLoader',{attrs:{"show-animation":""}},[_c('div',{staticClass:"loading-skeleton__title"}),_c('div',{staticClass:"loading-skeleton__filters"}),_vm._l((5),function(index){return _c('div',{key:index,staticClass:"loading-skeleton__item"})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }